import React from 'react'
import { CardHeader, Box } from '@mui/material'
import { MasterManagement } from '../mastersManagement/MasterManagement'
import { useParams } from 'infrastructure/routing'
import { ProductNavigation } from './masters_navigation/MastersNavigation'

export function Masters() {
  const { treeId: currentMasterId } = useParams()

  return (
    <Box>
      <CardHeader title={`Curriculum Masters`} />
      <Box padding="5px">
        This is an index of all current bundled curricula. If you are in the
        production environment you will see the masters grouped by partner. You
        will also see the status of each group, only Active curricula should be
        associated with current users.
      </Box>
      <Box padding={'5px'} display={'flex'}>
        <Box width="30%">
          <ProductNavigation />
        </Box>
        <Box padding={'5px'} display={'flex'} width="70%">
          {currentMasterId && (
            <Box padding={'10px'} flexGrow={1}>
              <MasterManagement masterId={currentMasterId} />
            </Box>
          )}
        </Box>
      </Box>
    </Box>
  )
}
